export default (() => {

    const MULTIPLE_DELEGATE_DISCOUNT_RATE = .1;
    const VAT_RATE = .2;
    const NON_EU_VAT_RATE = 0;

    const PROMOTION_TYPE_UNKNOWN = 0;
    const PROMOTION_TYPE_FIXED_VALUE = 1;
    const PROMOTION_TYPE_FIXED_PERCENTAGE = 2;

    function calculatePromotionsValue(promotions) {

        return parseFloat(promotions.reduce((carry, promo) => parseFloat(carry + promo.amount), 0));
    }

    function getPromotionValue(promotion, subtotal) {

        switch (promotion.type) {

            case 'fixed_value': {

                return parseFloat(promotion.value);
            }

            case 'fixed_percentage': {

                const percent = parseFloat(promotion.value / 100);

                return parseFloat(subtotal * percent);
            }

            default:
                return 0.0;
        }
    }

    function calculateMultiDelegateDiscount(options, subtotal, discounts) {

        if (options.course && options.course.allow_multi_delegate_discount) {

            const count = options['delegates'].length;

            const discountedSubtotal = parseFloat(subtotal - discounts);

            if (count > 1) {

                return parseFloat(discountedSubtotal * MULTIPLE_DELEGATE_DISCOUNT_RATE);

            } else {

                return 0.0;
            }

        } else {

            return 0.0;
        }
    }

    function calculateVAT(options, subtotal, discounts) {

        const multiDelValue = parseFloat(calculateMultiDelegateDiscount(options, subtotal, discounts));

        const subtotalDiscounted = parseFloat((subtotal - discounts - multiDelValue));

        const vat = parseFloat(subtotalDiscounted * (options.include_vat ? VAT_RATE: NON_EU_VAT_RATE));

        return vat < 0 ? 0.0 : vat;
    }

    function calculateTotalExcVAT(options, subtotal, discounts) {

        const multiDelDiscount = parseFloat(calculateMultiDelegateDiscount(options, subtotal, discounts));

        const total = parseFloat((subtotal - discounts - multiDelDiscount));

        return total < 0 ? 0.0 : total;
    }

    function calculateTotal(options, subtotal, discounts) {

        const multiDelDiscount = parseFloat(calculateMultiDelegateDiscount(options, subtotal, discounts));
        const vat              = parseFloat(calculateVAT(options, subtotal, discounts));

        const total = parseFloat((subtotal - discounts - multiDelDiscount) + vat);

        return total < 0 ? 0.0 : total;
    }

    function calculateSubtotal(options) {

        const delegatePrices = calculateDelegatePrices(options);

        return parseFloat(delegatePrices.reduce((carry, delegate) => parseFloat(delegate.price) + carry, 0)).toFixed(2);
    }

    function getPromotionTypeId(type) {
        switch (type) {
            case 'fixed_value':
                return PROMOTION_TYPE_FIXED_VALUE;
            case 'fixed_percentage':
                return PROMOTION_TYPE_FIXED_PERCENTAGE;
            default:
                return PROMOTION_TYPE_UNKNOWN;
        }
    }

    function calculatePromotions(options, promotionType, subtotal = 0.0) {

        let promotions = options['promotion_codes'].map((promo) => {
            return {
                ...promo,
                label: promo.code,
                amount: parseFloat(getPromotionValue(promo, subtotal).toFixed(2)),
                discount: promo.value,
                type: promo.type,
                sort: getPromotionTypeId(promo.type)
            }
        });

        return promotions.filter(promo => promo.type === promotionType);
    }

    function calculateNonPercentagePromotions(promos) {

        return parseFloat(promos.reduce((carry, promo) =>  carry + promo.amount, 0));
    }

    function getPricePerElearningUnit(totalUnits) {
         if (totalUnits < 4) {
            return 25.00;
        } else if (totalUnits < 7) {
            return 22.00;
        } else if (totalUnits < 10) {
            return 18.00;
        } else {
            return 15.00;
        }
    }

    function calculateDelegatePrices(options) {
        if (options.is_elearning_course) {
            return options.delegates.map(delegate => {
                if (options.course.overridden_price) {
                    return {
                        ...delegate,
                        price: parseFloat(options.course.overridden_price).toFixed(2)
                    }
                } else {
                    return {
                        ...delegate,
                        price: parseFloat(delegate.unit_ids.length * getPricePerElearningUnit(delegate.unit_ids.length)).toFixed(2)
                    }
                }
            });
        } else {
            return options.delegates.map(delegate => {
                return {
                    ...delegate,
                    price: parseFloat(options['full_delegate_price']).toFixed(2)
                }
            });
        }
    }

    function calculate(options) {

        const fixedValuePromotions = calculatePromotions(options, 'fixed_value');
        const nonPercentageValues = parseFloat(calculateNonPercentagePromotions(fixedValuePromotions));
        const subtotal = parseFloat(calculateSubtotal(options));
        const subtotalMinusNonPercentageValues = parseFloat(subtotal - nonPercentageValues);
        const percentagePromotions = calculatePromotions(options, 'fixed_percentage', subtotalMinusNonPercentageValues);
        const percentageValue = calculatePromotionsValue(percentagePromotions);
        let promotions = fixedValuePromotions.concat(percentagePromotions);

        return {
            delegate_costs: calculateDelegatePrices(options),
            subtotal: subtotal,
            total_vat: parseFloat(calculateVAT(options, subtotalMinusNonPercentageValues, percentageValue).toFixed(2)),
            total_exc_vat: parseFloat(calculateTotalExcVAT(options, subtotalMinusNonPercentageValues, percentageValue).toFixed(2)),
            delegate_discount_value: parseFloat(calculateMultiDelegateDiscount(options, subtotalMinusNonPercentageValues, percentageValue).toFixed(2)),
            total: parseFloat(calculateTotal(options, subtotalMinusNonPercentageValues, percentageValue).toFixed(2)),
            promotions: promotions
        };
    }

    return {
        calculate
    };

})();


// WEBPACK FOOTER //
// ./services/costCalculator.js